export default __webpack_public_path__ + "0c01d97e84e12ee879455f392a21dcbb.png";